// extracted by mini-css-extract-plugin
export default {"icon":"styles-module__icon__src-labstep-web-components-Signature-Header-_VP7_Z"};